import { RESET_FORM, SET_LOGGED_USER, SET_LOGGED_SPREMIUM_USER } from "./types";

const initialState = {
  loggedUser: null,
  resetRegisterFields: false,
  loggedSPremiumUser: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_LOGGED_USER:
      return {
        ...state,
        loggedUser: action.payload,
      };
    case RESET_FORM:
      return {
        ...state,
        resetRegisterFields: action.payload,
      };
    case SET_LOGGED_SPREMIUM_USER:
      return {
        ...state,
        loggedSPremiumUser: action.payload,
      };
    default:
      return state;
  }
};
